import Alpine from 'alpinejs';


Alpine.data("otpForm", (id, otp) => {
  return {
    digits: otp && otp.length == 6 ? otp.split("") : ["", "", "", "", "", ""],

    init() {
      document.querySelector('#'+id+'digit0').focus();
    },

    onInput(index, event) {
      let val = event.target.value;
      if (val.length > 1) val = val.slice(-1); // Only last character
      this.digits[index] = val;

      if (val && index < 5) {
        document.querySelector('#'+id+'digit' + (index + 1)).focus();
      }

      // Dispatch after next tick to ensure model is updated
      this.$nextTick(() => {
        if (this.digits.every(d => d.length === 1)) {
          this.$dispatch('otp');
        }
      });
    },

    onBackspace(index, event) {
      if (!this.digits[index] && index > 0) {
        this.digits[index-1] = ""
        document.querySelector('#'+id+'digit' + (index - 1)).focus();
      }
    },

    onFocus(index) {
      // Move to first empty input on focus
      for (let i = 0; i < this.digits.length; i++) {
        if (this.digits[i] === "") {
          document.querySelector('#'+id+'digit' + i).focus();
          break;
        }
      }
    },

    onPaste(event) {
      const pasted = (event.clipboardData || window.clipboardData).getData('text');
      const digits = pasted.replace(/\D/g, '').slice(0, 6).split('');
      if (digits.length) {
        event.preventDefault();
        digits.forEach((char, i) => {
          this.digits[i] = char;
          if (this.$refs['digit' + i]) {
            this.$refs['digit' + i].value = char;
          }
        });

        // Focus next available
        for (let i = 0; i < digits.length; i++) {
          if (i < 5 && this.digits[i + 1] === "") {
            this.$refs['digit' + (i + 1)].focus();
            break;
          }
        }

        // Dispatch after fill
        this.$nextTick(() => {
          if (this.digits.every(d => d.length === 1)) {
            this.$dispatch('otp');
          }
        });
      }
    }
  }
})